const setDefaultValue = (data, info, setField) => {

    for (let d = 0; d < data.length; d++) {
        for (let r = 0; r < data[d].boxes.length; r++) {
            for (let u = 0; u < data[d].boxes[r].fields.length; u++) {

                let idField = `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].id}`;
                setDefaultValueField(data[d].boxes[r].fields[u].type, data[d].boxes[r].fields[u].defaultValue, data[d].boxes[r].fields[u].sourceSelect, idField, info, setField, data[d].boxes[r].fields[u].idFieldTable);

                if (data[d].boxes[r].fields[u].group !== null) {
                    for (let g = 0; g < data[d].boxes[r].fields[u].group.length; g++) {
                        for (let h = 0; h < data[d].boxes[r].fields[u].group[g].fields.length; h++) {
                            let idField = `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].group[g].fields[h].id}`
                            setDefaultValueField(data[d].boxes[r].fields[u].group[g].fields[h].type, data[d].boxes[r].fields[u].group[g].fields[h].defaultValue, data[d].boxes[r].fields[u].group[g].fields[h].sourceSelect, idField, info, setField, data[d].boxes[r].fields[u].group[g].fields[h].idFieldTable);

                            if (data[d].boxes[r].fields[u].group[g].fields[h].subGroup !== null) {
                                for (let q = 0; q < data[d].boxes[r].fields[u].group[g].fields[h].subGroup.length; q++) {
                                    for (let w = 0; w < data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields.length; w++) {

                                        let idField = `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields[w].id}`
                                        setDefaultValueField(data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields[w].type, data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields[w].defaultValue, data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields[w].sourceSelect, idField, info, setField, data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields[w].idFieldTable);
                                    }
                                }

                            }

                        }
                    }
                }
            }
        }
    }
}

const setDefaultValueField = (type, defaultValue, sourceSelect, idField, info, setField, idFieldTable) => {

    switch (type) {
        case 'Select':
            if (defaultValue) {
                info.forEach((itemInfo) => {
                    if (itemInfo.source === sourceSelect) {
                        if (Number(defaultValue) === Number(itemInfo.id))
                            setField(prevState => ({
                                ...prevState,
                                [idField]: {
                                    id: itemInfo.id,
                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                }
                            }), []);
                    }
                })
            }
            break;
        case 'Date':
            if (defaultValue === 'YESTERDAY()') {
                const date = new Date();
                date.setDate(date.getDate() - 1);
                setField(prevState => ({
                    ...prevState,
                    [idField]: date.toISOString().split('T')[0]
                }), []);
            }
            if (defaultValue === 'CURDATE()') {
                setField(prevState => ({
                    ...prevState,
                    [idField]: new Date().toISOString().split('T')[0]
                }), []);
            }
            if (defaultValue === 'BOM()') {
                const date = new Date();
                date.setDate(1);
                setField(prevState => ({
                    ...prevState,
                    [idField]: date.toISOString().split('T')[0]
                }));
            }
            if (defaultValue === 'BOY()') {
                const date = new Date();
                date.setMonth(0); // Enero
                date.setDate(1);  // Día 1
                setField(prevState => ({
                    ...prevState,
                    [idField]: date.toISOString().split('T')[0]
                }));
            }
            break;
        case 'TextField':
            if (defaultValue) {
                if (!defaultValue.includes('()'))
                    setField(prevState => ({
                        ...prevState,
                        [idField]: defaultValue
                    }), []);
            }
            break;
        case 'Switch':
            if (idFieldTable === 'isDefault') {
                setField(prevState => ({
                    ...prevState,
                    [idField]: true
                }), []);
            }
            break;
        default:
            break;
    }

}


export default setDefaultValue;